<template>
    <div class="login-container">
        <header>
            <img style="margin-top: 0px;width:600px;height: 84px;" src="../../assets/changchenglogo2.png" alt="">
        </header>
        <img class="backimg" src="../../assets/c_bei.png" alt="">
        <div class="content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
                <el-form-item label="企业名称" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入企业名称"></el-input>
                </el-form-item>
                <el-form-item label="统一社会信用代码" prop="code">
                    <el-input v-model="ruleForm.code" placeholder="请输入统一社会信用代码"></el-input>
                </el-form-item>
                <el-form-item label="法定代表人" prop="legalPersonname">
                    <el-input v-model="ruleForm.legalPersonname" placeholder="请输入法人名称"></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="date2">
                    <!-- <div style="display: flex"> -->


                    <el-input type="text" style="border-radius:none;" v-model="ruleForm.account" placeholder="请设置登录账号">
                        <!-- <template slot="append"> -->
                        <!-- <el-popover placement="top-start" title="提示" -->
                        <!-- trigger="hover" content="管理员的账号信息命名规则为：企业全称的前 4-6 位代表文字"> -->
                        <!-- <i class="iconfont icon-question-circle-fill" style="font-size: 25px;margin: 10px 5px 0 0px;"
                                        slot="reference"></i> -->
                        <!-- </el-popover> -->
                        <!-- </template> -->
                    </el-input>

                    <!-- </div> -->


                </el-form-item>
                <p style="font-size: 15px;color:gray;margin-left: 90px;">提示：请输入3-6位的企业简称("要求仅包含中文文字)</p>

                <!-- <el-form-item label="注册角色" prop="radio1">
                    <el-radio style="margin-right:400px;" v-model="ruleForm.radio1" label="1">管理员</el-radio>
                </el-form-item> -->


                <el-form-item label="账号密码" prop="password">
                    <el-input v-model="ruleForm.password" @input="password()" placeholder="请输入密码"></el-input>
                    <div class="input_span">
                        <span
                            :style="{ 'background': (msgText > 1 || msgText == 1) ? '#FC5F76' : '#ccc', 'color': (msgText > 1 || msgText == 1) ? '#FC5F76' : '#BBB' }">弱</span>
                        <span
                            :style="{ 'background': (msgText > 2 || msgText == 2) ? '#FF9900' : '#ccc', 'color': (msgText > 1 || msgText == 1) ? '#FF9900' : '#BBB' }">中</span>
                        <span
                            :style="{ 'background': (msgText > 4 || msgText == 4) ? '#33CC00' : '#ccc', 'color': (msgText > 1 || msgText == 1) ? '#33CC00' : '#BBB' }">强</span>
                    </div>
                </el-form-item>
                <p style="font-size: 15px;color:gray;margin-left: 150px;margin-top: 25px;">
                    提示：请输入8-16位，至少包含大写字母、小写字母、数字3种</p>

                <el-form-item label="联系人姓名" prop="contactName">
                    <el-input v-model="ruleForm.contactName" placeholder="请输入联系人姓名"></el-input>

                </el-form-item>
                <el-form-item label="联系人电话" prop="contactPhone">
                    <el-input v-model="ruleForm.contactPhone" oninput="value=value.replace(/[^0-9]/g,'')" placeholder="请输入联系人电话"></el-input>

                </el-form-item>
                <el-form-item label="短信验证码" prop="yzm">
                    <div style="display:flex;">
                        <el-input style="margin-right:5px;width: 80%;" placeholder="请输入您收到的短信验证码"
                            v-model="ruleForm.yzm"></el-input>
                        <div style="display:flex;">
                            <el-button  class="get-captcha-btn"  @click="getCaptcha($event)" :disabled="isCaptchaButtonDisabled"  :style="{ backgroundColor: isCounting ? '#DCB780' : '#DCB780', color: isCounting ? '#fff' : '#fff' }">
                            <!-- <div class="get-captcha-btn" @click="getCaptcha($event)"
                                :style="{ backgroundColor: isCounting ? '#DCB780' : '#DCB780', color: isCounting ? '#fff' : '#fff' }"> -->
                               <span style="display: flex;justify-content: center;">{{ isCounting ? countdownText : '获取验证码' }}</span> 
                            <!-- </div> -->
                        </el-button>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="所在地" prop="address">
                    <el-input v-model="ruleForm.address" placeholder="请输入所在地"></el-input>

                </el-form-item>
                <el-form-item label="推荐人" prop="recommend">
                    <el-input v-model="ruleForm.recommend" placeholder="请输入推荐人"></el-input>

                </el-form-item>


                <!-- <el-form-item label="手机号码" prop="resource" style="margin-top: 30px;">
                    <el-input v-model="ruleForm.resource" placeholder="请输入手机号"></el-input>
                    <div style="display: flex;margin-top: 14px;">
                        <el-input style="width:440px;" placeholder="请输入手机验证码" prefix-icon="el-icon-search"
                            v-model="input2">
                        </el-input>
                        <div
                            style="width: 110px;margin-left:10px; height: 38px;border-radius:5px;background-color:  #DCB780;color: white;">
                            发送短信</div>
                    </div>
                    <div style="display: flex;margin-top: 14px;">
                        <el-input style="width: 440px;" placeholder="请输入图形验证码" prefix-icon="el-icon-search"
                            v-model="input2">
                        </el-input>
                        <div style="width: 108px;height: 38px;border: 1px solid #ccc;margin-left:10px;"></div>

                    </div>
                </el-form-item> -->
                <el-form-item>
                    <el-button style="width:500px;font-size: 18px;border-radius: 8px;border: none;margin-top: 10px;"
                        type="warning" @click="zhuceclick()">立即注册</el-button>
                    <i class="iconfont icon-ziyuan" :style="iconclass" @click="iconclick('1')"></i>
                    <span style="margin-left:10px;">我已阅读并同意<span @click="pdfclick(ptfwxy)">{{ ptfwxy }}</span>和<span
                            @click="pdfclick(ptysxy)">{{ ptysxy }}</span> </span>
                </el-form-item>


            </el-form>
        </div>



        <el-dialog title="" :visible.sync="dialogVisible" width="65%" :before-close="handleClose">
            <pdf ref="pdf" class="pdf-preview" :src="fileUrl" :page="pageNum" :rotate="pageRotate"
                @num-pages="pageTotalNum = $event" @link-clicked="page = $event">
            </pdf>

        </el-dialog>
        <el-dialog title="申请已提交" :visible.sync="dialogVisible1" width="30%" style="top:25%;border-radius: 8px;"
            :before-close="handleClose">
            <span style="display: block; width:90%;margin: 20px auto;line-height: 30px;">您的注册已提交成功，请注意接听158 0104
                2343开头的手机号来电，平台将在1-3个工作日内以电话形式审核您的注册信息，并以电话/短信的形式通知您审核结果。</span>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogVisible1 = false">取 消</el-button> -->
                <el-button type="primary" @click="dialogVisible1 = false">确 认</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="dialogVisible2" width="30%" style="top:25%;border-radius: 8px;"
            :before-close="handleClose">
            <span style="display: block;margin: 30px auto;">{{ msgs }}</span>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogVisible1 = false">取 消</el-button> -->
                <el-button type="primary" @click="dialogVisible2 = false">确 认</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import { supplier_enter, getFilesName, getfilepath, authFileByUserId, getCodes, check } from '../../request/api'
import pdf from "vue-pdf";
export default {
    components: {
        pdf,
    },
    name: 'login',
    data() {
        return {
            isCounting: false, // 是否在倒计时
            countdown: 60,     // 倒计时秒数
            countdownText: '', // 倒计时文本
            dialogVisible1: false,
            dialogVisible2: false,
            msgs: "",
            fileUrl: "", //文件路径
            pageNum: 1,
            pageTotalNum: 1,
            pageRotate: 0,
            customHeight: 400,
            ptfwxy: "",
            ptysxy: "",
            dialogVisible: false,
            activeName: 'first',
            ruleForm: {
                // password:"Abc123456"
                yzm: '',
                contactPhone: ''

            },
            rules: {
                // name: [
                //     { required: true, message: '请输入企业名称', trigger: 'blur' }
                // ],
                // code: [
                //     { required: true, message: '请输入统一社会信用代码', trigger: 'change' }
                // ],
                // legalPersonname: [
                //     { required: true, message: '请输入法定代表人', trigger: 'change' }
                // ],
                // date2: [
                //     { required: true, message: '请输入账号', trigger: 'change' }
                // ],
                // password: [
                //     { required: true, message: '请输入密码', trigger: 'change' }
                // ],

                // resource: [
                //     { required: true, message: '请输入手机号', trigger: 'change' }
                // ],
                // desc: [
                //     { required: true, message: '请填写活动形式', trigger: 'blur' }
                // ],
                // radio1: [
                //     { required: true, message: '请选择注册角色', trigger: 'blur' }
                // ]


            },
            rules: {
                // name: [
                //     { required: true, message: '请输入企业名称', trigger: 'blur' }
                // ],
                // ...（省略其他校验规则）
                contactPhone: [
                    { required: true, message: '请输入联系人电话', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' }
                ],
                yzm: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    // { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }

                ],

            },
            msgText: "",
            iconclass: {
                color: '#BBB',
                fontSize: '16px'
            },
            state: '',
            timer: "",
            isCaptchaButtonDisabled:false
        }
    },

    watch: {
        'ruleForm.password': {
            handler(keyWord, oldname) {
                // console.log("keyWord:", keyWord)
                this.msgText = this.checkStrong(keyWord);
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    created() {
        const savedTime = localStorage.getItem('captchaCountdown1');
        const startTime = localStorage.getItem('captchaStartTime1');

        if (savedTime && startTime) {
            // 计算已经过去的时间
            const elapsedSeconds = Math.floor((Date.now() - parseInt(startTime)) / 1000);
            const remaining = parseInt(savedTime) - elapsedSeconds;

            if (remaining > 0) {
                this.countdown = remaining;
                this.isCounting = true;
                this.startCountdown();
            } else {
                this.resetCountdown();
            }
        }
        if (this.ruleForm.password) {
            this.msgText = this.checkStrong(this.ruleForm.password);
        }

        this.datalist()
    },
    methods: {
        getCaptcha(event) {
            event.preventDefault();

            this.$refs.ruleForm.validateField('contactPhone', (valid) => {
                console.log(valid, '验证结果：' + this.ruleForm.contactPhone);

                if (!valid) { // valid为false表示验证通过
                    console.log(this.ruleForm.contactPhone, '获取手机号');
                    getCodes(this.ruleForm.contactPhone).then(res => {
                        console.log(res, '验证码发送结果');

                        if (res.code === 200) {
                            this.$message.success('验证码已发送，请注意查收！');
                            this.isCaptchaButtonDisabled = true; // 设置按钮为禁用状态
                            console.log(this.isCaptchaButtonDisabled, '按钮状态');
                            
                        } else {
                            this.$message.error(res.msg)
                        }
                    });

                    if (!this.isCounting) {
                        this.startCountdown();
                    }
                } else {
                    console.error('手机号格式不正确，请重新输入');
                }
            });
        },

        startCountdown() {
            // 从本地存储获取剩余时间，如果没有则为60秒
            const savedTime = localStorage.getItem('captchaCountdown1');
            this.countdown = savedTime ? parseInt(savedTime) : 60;

            this.isCounting = true;
            this.updateCountdownText();

            // 存储开始时间戳
            localStorage.setItem('captchaStartTime1', Date.now().toString());
            localStorage.setItem('captchaCountdown1', this.countdown.toString());

            this.timer = setInterval(() => {
                this.countdown--;
                this.updateCountdownText();
                localStorage.setItem('captchaCountdown1', this.countdown.toString());

                if (this.countdown <= 0) {
                    this.resetCountdown();
                }
            }, 1000);
        },

        updateCountdownText() {
            this.countdownText = this.countdown + '秒';
        },

        resetCountdown() {
            clearInterval(this.timer);
            this.isCounting = false;
            this.countdown = 60;
            this.countdownText = '获取验证码';
            this.isCaptchaButtonDisabled = false; // 设置按钮为禁用状态
            localStorage.removeItem('captchaStartTime1');
            localStorage.removeItem('captchaCountdown1');
        },
        // handleInput(value) {
        //     // 使用正则表达式匹配3到6位中文字符
        //     const chineseRegex = /^[\u4e00-\u9fa5]{3,6}$/;
        //     if (chineseRegex.test(value)) {
        //         this.ruleForm.account = value; // 如果匹配，更新表单值
        //     } else {
        //         // 如果不匹配，可以清空或保持原值，这里选择清空
        //         // this.rawInput = '';
        //         // this.ruleForm.account = '';
        //         // 可选：给出提示信息，告知用户输入不符合要求
        //         this.$message.warning('请输入3到6位中文文字');
        //     }
        // },
        handleClose(done) {
            done();

        },
        pdfclick(date) {
            console.log('date:', date);
            // this.dialogVisible = true;
            if (date == '《平台用户服务协议》') {
                getFilesName().then(res => {
                    // this.fileUrl = 'http://192.168.1.50:28000/profile/' + res.data[0].filePath;
                    // window.open(`http://192.168.1.50:28000/profile/${res.data[0].filePath}`)
                    window.open(`${getfilepath}${res.data[0].filePath}`)
                })

            } else if (date == '《平台隐私政策》') {
                getFilesName().then(res => {
                    // this.fileUrl = 'http://192.168.1.50:28000/profile/' + res.data[1].filePath;
                    window.open(`${getfilepath}${res.data[1].filePath}`)

                })

            }

        },
        datalist() {
            getFilesName().then(res => {
                this.ptfwxy = res.data[0].fileName;
                this.ptysxy = res.data[1].fileName;

            })
        },
        iconclick(state) {

            this.state = state;
            console.log("iconclick");
            this.iconclass = {
                fontSize: '16px',
                color: '#D4B887'
            }
        },
        zhuceclick() {
            console.log(this.ruleForm.contactPhone);


            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    //         // 表单验证通过，执行注册逻辑
                    console.log('表单验证通过，执行注册逻辑');
                    if (!this.ruleForm.name) {
                        this.$message.warning('请输入企业名称');
                        return;
                    }
                    if (!this.ruleForm.code) {
                        this.$message.warning('统一社会信用代码');
                        return;
                    }
                    if (!this.ruleForm.legalPersonname) {
                        this.$message.warning('请输入法定代表人');
                        return;
                    }
                    if (!this.ruleForm.account) {
                        this.$message.warning('请输入登录账号');
                        return;
                    }
                    if (!this.ruleForm.password) {
                        this.$message.warning('请输入账号密码');
                        return;
                    }
                    if (!this.ruleForm.contactName) {
                        this.$message.warning('请输入联系人姓名');
                        return;
                    }
                    if (!this.ruleForm.contactPhone) {
                        this.$message.warning('请输入联系人电话');
                        return;
                    }
                    if (!this.ruleForm.address) {
                        this.$message.warning('请输入所在地');
                        return;
                    }









                    const chineseRegex = /^[\u4e00-\u9fa5]{3,6}$/;
                    if (chineseRegex.test(this.ruleForm.account)) {
                        this.ruleForm.account = this.ruleForm.account;
                    } else {

                        this.$message.warning('登录账号:请输入3-6位的企业简称("要求仅包含中文文字)');
                        return;
                    }

                    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,16}$/;
                    this.isPasswordInvalid = !passwordRegex.test(this.ruleForm.password);

                    // 如果密码无效，可以在这里添加额外的逻辑，如清空密码或给出提示
                    if (this.isPasswordInvalid) {
                        // 可选：清空密码输入框，根据实际需求决定是否启用
                        // this.ruleForm.password = '';
                        this.$message.warning('账号密码:请输入8-16位，至少包含大写字母、小写字母、数字3种');
                        return;
                    }



                    if (this.state == '') {
                        return this.$message({
                            message: '请勾选同意《平台用户服务协议》/《平台隐私政策》',
                            type: 'info'
                        });
                    } else {
                        check({
                            phone: this.ruleForm.contactPhone,
                            code: this.ruleForm.yzm
                        }).then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: res.msg
                                });
                                this.ruleForm.sourceFrom = '1';
                                supplier_enter(this.ruleForm).then(res => {
                                    if (res.code == 200) {

                                        this.dialogVisible1 = true;
                                        let param = {
                                            types: [1, 2],
                                            code: res.supplierEnter.code,
                                            userId: res.user.userId
                                        }
                                        authFileByUserId(param).then(res => {

                                        })
                                    } else {
                                        this.msgs = res.msg;
                                        this.dialogVisible2 = true;


                                    }
                                })
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                });
                            }
                        })




                    }

                    // ...（注册逻辑代码）
                } else {
                    // 表单验证未通过，给出提示
                    console.log('表单验证未通过');
                    return false;
                }
            });





        },
        checkStrong(sValue) {
            var modes = 0;
            //正则表达式验证符合要求的
            if (sValue.length < 1) return modes;
            if (/\d/.test(sValue)) modes++; //数字
            if (/[a-z]/.test(sValue)) modes++; //小写
            if (/[A-Z]/.test(sValue)) modes++; //大写
            if (/\W/.test(sValue)) modes++; //特殊字符
            // console.log("modes:", sValue.length, modes)
            //逻辑处理
            switch (modes) {
                case 1:
                    return 1;
                    break;
                case 2:
                    return 2;
                    break;
                case 3:
                case 4:
                    return sValue.length < 4 ? 3 : 4;
                    break;
            }
            return modes;
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        password() {
            const password = this.ruleForm.password;
            let strength = '弱';

            if (password.length >= 8) {
                if (/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(password)) {
                    strength = '强';
                } else if (/(?=.*[a-z])(?=.*[A-Z])|(?=.*[a-z])(?=.*\d)|(?=.*[A-Z])(?=.*\d)/.test(password)) {
                    strength = '中';
                }
            }

            // passwordStrength.textContent = strength;
        }
    }
}
</script>
<style scoped lang="scss">
.login-container {
    width: 100%;
    height: 100%;
}

::v-deep .el-radio__inner {
    // background-color: #DCB780;
    // border-color: #DCB780;
    // background: #DCB780;
}

::v-deep .el-form-item {
    margin-bottom: 0 !important;
    margin-top: 14px;
}

::v-deep .el-input-group__append {
    line-height: 48px;
}

::v-deep .el-popover__reference-wrapper {
    margin-left: -14px;

}

::v-deep .el-dialog {
    border-radius: 8px !important;
}

::v-deep .el-button--primary {
    background-color: #DCB780;
    border-color: #DCB780;
}

::v-deep .el-button--primary:hover {
    background-color: #DCB780;
    border-color: #DCB780;
}

::v-deep .el-button--defaul {
    background-color: white;
    border-color: black;
}

::v-deep .el-button--defaul:hover {
    background-color: white !important;
    border-color: black;
}

::v-deep .el-input__inner {
    background: rgba(0, 0, 0, 0.06) !important;
    border-radius: 8px;
    height: 50px !important;
    border: none;
}

::v-deep .el-message {
    margin-top: 1200px !important;
    /* 调整为你希望的高度 */
}

::v-deep .el-message .el-message--info {
    top: 800px !important;
}

.input_span {
    height: 8px;
    display: flex;
    // float: right;
    width: 35%;
    margin-top: 10px;

    span {
        display: inline-block;
        width: 30%;
        border-radius: 8px;
        margin-right: 3px;
        text-align: center;
        margin-top: 3px;
        height: 2px;
        background: rgba(0, 0, 0, 0.02);
    }
}

::v-deep .el-tabs__active-bar {
    background-color: #DCB780;
    /* 例如 #ff0000 是红色 */
}

::v-deep .is-active {
    color: black !important;
}

::v-deep .el-form-item__label {
    font-size: 18px;
    margin-top: 5px;
}

header {
    width: 100%;
    height: 80px;
    font-size: 30px;
    color: #C49958;
    background-color: #F1F1F1;
    line-height: 80px;
}

.backimg {
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
}

.content {
    width: 100%;
    z-index: 999;

    .el-form {
        width: 700px;
        margin: 40px auto;
        margin-left: 511px;

        .el-button {
            display: block;
            // margin: 0 auto;
            width: 362px;
            height: 50px;
            // margin-left: -128px;
            background: linear-gradient(180deg, #DCB780 0%, #C49958 100%)
        }

    }

    .el-input {
        width: 500px;
        height: 50px;
        display: block;
        display: flex;
    }


}

.iconfont:hover {
    color: #D4B887;
    cursor: pointer;
}

::v-deep .el-dialog__body {
    padding: 0 !important;
}

::v-deep .get-captcha-btn {
    width: 94px !important;
    height: 40px;
    background: #DCB780;
    margin-top: 5px;
    cursor: pointer;
    text-align: center !important;
    margin: 0 auto;
    display: flex;
    justify-content: center;
   
}

::v-deep .el-form-item__label:before {
    display: none !important;
}


</style>